// chakraStyles.js
export const styles = {
  mainWrapper: {
    direction: "column",
    bg: "#d9d6ed",
    w: ["100%", "45vw"],
    p: 3,
    // ml: 3,
    borderRadius: "0px 20px 20px 20px",
    gap: 2,
    userSelect: "none",
    ml: [0, '54px'],
  },
  listingContainer: {
    display: "flex",
    direction: "column",
  },
  listingTitle: {
    fontWeight: "500",
    fontSize: "14px",
    as: "div",
    color: "#130159",
  },
  flexRow: {
    direction: "row",
    gap: 2,
    py: 2,
    flexWrap: "wrap",
  },
  button: (isSelected, width) => ({
    p: width === "80%" ? "6px 16px" : "4px",
    bg: isSelected ? "#8f82d7" : "white",
    borderRadius: "full",
    spacing: "4px",
    border: "1px solid #b4addc",
    cursor: "pointer",
    w: width,
    justifyContent: width === "80%" ? "flex-start" : "center",
  }),
  buttonText: (isSelected, isEnabled) => ({
    fontWeight: "500",
    fontSize: "12px",
    as: "div",
    color: isEnabled ? "green" : isSelected ? "white" : "#130159",
  }),
  subtopicsBlock: {
    box: {
      p: "0px 16px 8px 16px",
    },
    title: {
      fontWeight: "500",
      fontSize: "14px",
      color: "#130159",
      py: 2,
    },
    container: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      gap: 2,
    },
  },
  otherActionsWrapper:{
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },
    buttonStyle1: {
      backgroundColor: "grey",
      color: "white",
    },
    buttonStyle2: {
      backgroundColor: "#800000",
      color: "white",
    },
    buttonStyle3: {
      backgroundColor: "#FFB300",
      color: "white",
    },
    buttonStyle4: {
      backgroundColor: "red",
      color: "white",
    },
    buttonStyle5: {
      backgroundColor: "#FF69B4",
      color: "white",
    },
    buttonStyle6: {
      backgroundColor: "orange",
      color: "white",
    },
    buttonStyle7: {
      backgroundColor: "#FFD700",
      color: "white",
    },
    buttonStyle8: {
      backgroundColor: "green",
      color: "white",
    },
};
